




















































































import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Menu from '@/components/common/Menu.vue';
import { usersService } from '../../services/UsersService';

@Component({
  components: {
    Header,
    Menu,
  },
})
export default class NewUser extends Vue {
  workspaceId = 0;
  selectedRole = 'owner';
  email = '';
  errors: any = [];
  isLoading = false;
  isActiveEmailValidation: boolean = false;

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.email = '';
    this.selectedRole = 'owner';
  }
  isEmailValid(email: string) {
    return (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      ) &&
      email &&
      this.errors.length === 0
    );
  }
  sendInvitation() {
    this.isActiveEmailValidation = true;
    this.errors = [];
    if (
      !this.email ||
      (this.email &&
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        )) ||
      this.isLoading
    ) {
      return;
    }
    this.isLoading = true;
    usersService
      .createInvitation(this.workspaceId, this.email, this.selectedRole)
      .then(() => {
        this.isLoading = false;
        this.$router.push(`/workspaces/${this.workspaceId}/users`).catch(() => {});
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data.status === 422) {
          if (data.data && data.data.error && data.data.error.email) {
            if (data.data && data.data.error && data.data.error.email[0].error === 'blacklisted') {
              this.errors.push(this.$t('error.email.blacklisted'));
            } else if (data.data && data.data.error && data.data.error.email[0].error === 'invalid') {
              this.errors.push(this.$t('isWrongFormat'));
            } else {
              this.errors.push(this.$t('scripts.emailIsAlreadyInUse'));
            }
          }
        }
        if (data.status === 403) {
          if (data.data && data.data.error === 'Insufficient permissions') {
            this.errors.push(this.$t('scripts.insufficientPermissions'));
          }
        }
      });
  }
}
